import { Component, State, Listen, h } from '@stencil/core';
import Helmet from '@stencil/helmet';

import URLS from '../app-root/urls';
const pageInfo = {
  pageURL: URLS.AppPriceSlider,
  pageTitle: 'Cennik - ZENTO Magento 2 PWA SaaS',
  pageDescription: "Cennik, który ma sens. Jeden plan, który pokryje wszystkie Twoje potrzeby. Skalowalny w miarę wzrostu.",
  keywords: "Zento pricing, monthly subscription fee",
  ogimage: 'assets/icon/var_og-image.png'
};

// function formatAmount(labelValue) {

//   // Nine Zeroes for Billions
//   return Math.abs(Number(labelValue)) >= 1.0e+9

//   ? Math.abs(Number(labelValue)) / 1.0e+9 + "B"
//   // Six Zeroes for Millions
//   : Math.abs(Number(labelValue)) >= 1.0e+6

//   ? Math.abs(Number(labelValue)) / 1.0e+6 + "M"
//   // Three Zeroes for Thousands
//   : Math.abs(Number(labelValue)) >= 1.0e+3

//   ? Math.abs(Number(labelValue)) / 1.0e+3 + "k"

//   : Math.abs(Number(labelValue));

// }

@Component({
  tag: 'app-price-slider',
  styleUrl: 'style.scss',
  shadow: false,
  scoped: false
})
export class AppPriceSlider {
  static pricing = [
    {
      minTurnover: 0,
      maxTurnover: 500000,
      minOrders: 0,
      maxOrders: 500,
      setup: 7000,
      subscription: 490,
      hosting: 120
    },
    {
      minTurnover: 500000,
      maxTurnover: 1000000,
      minOrders: 500,
      maxOrders: 1000,
      setup: 7000,
      subscription: 990,
      hosting: 190
    },
    {
      minTurnover: 1000000,
      maxTurnover: 2000000,
      minOrders: 1000,
      maxOrders: 2500,
      setup: 9000,
      subscription: 1490,
      hosting: 300
    },
    {
      minTurnover: 2000000,
      maxTurnover: 4000000,
      minOrders: 2500,
      maxOrders: 5000,
      setup: 12000,
      subscription: 2490,
      hosting: 400
    },
    {
      minTurnover: 4000000,
      maxTurnover: 8000000,
      minOrders: 5000,
      maxOrders: 10000,
      setup: 19000,
      subscription: 3990,
      hosting: 650
    },
    {
      minTurnover: 8000000,
      maxTurnover: 12000000,
      minOrders: 10000,
      maxOrders: 20000,
      setup: 29000,
      subscription: 5990,
      hosting: 1100
    },
    {
      minTurnover: 12000000,
      maxTurnover: null,
      minOrders: 20000,
      maxOrders: null,
      setup: null,
      subscription: null,
      hosting: null
    }
  ];
  static includedBullets = {
    subscription: [
      {
        label: 'Monitorowanie aplikacji 24/7',
        link: null,
        zento: true,
        merchant: false
      },
      {
        label: 'Monitoring bezpieczeństwa 24/7',
        link: null,
        zento: true,
        merchant: false
      },
      {
        label: 'Magento Aktualizacje poprawek jakości i bezpieczeństwa',
        link: null,
        zento: true,
        merchant: false
      },
      {
        label: 'Certyfikat SSL',
        link: null,
        zento: true,
        merchant: false
      },
      {
        label: 'Dodanie nowych funkcji Zento',
        link: null,
        zento: true,
        merchant: false
      },
      {
        label: 'Wsparcie poprzez system biletowy',
        link: null,
        zento: true,
        merchant: false
      },
      {
        label: 'Kampanie marketingowe',
        link: null,
        zento: false,
        merchant: true
      },
      {
        label: 'Zarządzanie zamówieniami',
        link: null,
        zento: false,
        merchant: true
      },
      {
        label: 'Zarządzanie katalogiem i treścią',
        link: null,
        zento: false,
        merchant: true
      },
    ],
    setup: [
      {
        label: 'Tworzenie i wdrażanie projektu w Zento PWA',
        link: null,
        zento: true,
        merchant: false
      },
      // {
      //   label: 'Localisation and configuration (Privacy and Cookie Policies, Terms and Conditions etc), tax configurations',
      //   link: null,
      //   zento: false,
      //   merchant: true
      // },
      // {
      //   label: 'Configuring transactional emails',
      //   link: null,
      //   zento: true,
      //   merchant: false
      // },
      {
        label: 'Przygotowanie kategorii, atrybutów, produktów w zgodnym formacie (jeśli nie migracja)',
        link: null,
        zento: false,
        merchant: true
      },
      {
        label: 'Ręczne dodawanie kategorii, atrybutów, produktów w panelu Zento',
        link: null,
        zento: false,
        merchant: true
      },
      {
        label: 'Migracja ze starych platform open source',
        link: null,
        zento: true,
        merchant: true
      },
      {
        label: 'Dodawanie dodatkowych stron statycznych',
        link: null,
        zento: false,
        merchant: true
      },
      {
        label: 'Publikowanie treści na blogu',
        link: null,
        zento: false,
        merchant: true
      },
      {
        label: 'Konfigurowanie bram płatniczych i wysyłkowych',
        link: null,
        zento: false,
        merchant: true
      },
      {
        label: 'Integracje narzędzi marketingowych (Google Tag Manager, Facebook Pixel etc.)',
        link: null,
        zento: false,
        merchant: true
      },
      {
        label: 'Włączanie opcjonalnych dodatków Zento',
        link: null,
        zento: true,
        merchant: false
      },
      {
        label: 'Ostateczne testy akceptacyjne i uruchomienie',
        link: null,
        zento: false,
        merchant: true
      },
    ]
  };

  @State() showModal: boolean = false;
  @State() sliderValue: number = 1;

  @Listen('closeModalEvent')
  closeModalHandler() {
    this.showModal = false;
  }

  openModaldHandler() {
    this.showModal = true;
  }

  valueChangedHandler(event: any) {
    this.sliderValue = parseInt(event.target.value);
  }

  componentDidRender() {
    document.title = pageInfo.pageTitle;
    document.querySelector('meta[name="Description"]').setAttribute('content', pageInfo.pageDescription);
    document.querySelector('meta[property="og:description"]').setAttribute('content', pageInfo.pageDescription);
  }
  render() {
    let counter = 0;
    return (
      <div class='price-wrapper'>
        <Helmet>
          <title>{pageInfo.pageTitle}</title>
          <meta name="Description" content={pageInfo.pageDescription} />
          <meta name="keywords" content={pageInfo.keywords} />
          <meta property="og:description" content={pageInfo.pageDescription} />
          <meta property="og:image" content={process.env.BASEURL + pageInfo.ogimage} />
          <meta property="og:site_name" content="ZENTO" />
          <meta property="og:title" content={pageInfo.pageTitle} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={process.env.BASEURL + pageInfo.pageURL.substr(1,pageInfo.pageURL.length)} />
        </Helmet>

        <div class='pages-introduction'>
          <h2>Cennik, który ma sens</h2>
          <p>Jeden plan, który pokryje wszystkie Twoje potrzeby. Skalowalny w miarę wzrostu.</p>
        </div>
        <div class='price-page-slider-wrapper'>
          <div class='range'>
            <input
              type='range'
              class='slider'
              min='1'
              max='7'
              value={ this.sliderValue }
              onChange={(event) => this.valueChangedHandler(event)}
            />
          </div>
          <ul class='range-labels'>
            {AppPriceSlider.pricing.map(p => {
              return <li class={
                {
                  'range-item': true,
                  'active': this.sliderValue === ++counter,
                }
              }>
                {/* { p.minTurnover===0 ? <span>&lt; €{ formatAmount(p.maxTurnover) } / rok</span> : ''}
                { p.minTurnover!==0 && p.maxTurnover!==null ? <span>€{ formatAmount(p.minTurnover) } - €{ formatAmount(p.maxTurnover) } / rok</span> : ''}
                { p.maxTurnover===null ? <span>&gt; €{ formatAmount(p.minTurnover) } / rok</span> : ''} */}
                { p.minOrders===0 ? <span>&lt; { p.maxOrders } zamówienia / miesiąc</span> : ''}
                { p.minOrders!==0 && p.maxOrders!==null ? <span>{ p.minOrders } - { p.maxOrders }</span> : ''}
                { p.maxOrders===null ? <span>&gt; { p.minOrders } zamówienia / miesiąc</span> : ''}
                <div class='range-tooltip-wrapper'>
                      { p.setup !== null ?
                        <div class='range-tooltip-inner'>
                          <div class='zento-prices'><span>Opłata inicjacyjna</span>
                            <p>€{ new Intl.NumberFormat('en-US').format(p.setup) } <span>(1 raz)</span></p>
                          </div>
                          <div class='zento-prices'><span>Subskrypcja</span>
                            <p>€{ new Intl.NumberFormat('en-US').format(p.subscription) } / miesięcznie</p>
                            <em>+€{ new Intl.NumberFormat('en-US').format(p.hosting) }/miesięcznie hosting (prognozowany)</em>
                          </div>
                          <div class='turnover-rage-price'>
                            {/* { p.minTurnover===0 ? <p>&lt; €{ formatAmount(p.maxTurnover) } sprzedaży / rok</p> : ''}
                            { p.minTurnover!==0 && p.maxTurnover!==null ? <p>€{ formatAmount(p.minTurnover) } - €{ formatAmount(p.maxTurnover) } sprzedaży / rok</p> : ''}
                            { p.maxTurnover===null ? <p>&gt; €{ formatAmount(p.minTurnover) } sprzedaży / rok</p> : ''} */}
                            { p.minOrders===0 ? <span>&lt; { p.maxOrders } zamówienia / miesiąc</span> : ''}
                            { p.minOrders!==0 && p.maxOrders!==null ? <span>{ p.minOrders } - { p.maxOrders } zamówienia / miesiąc</span> : ''}
                            { p.maxOrders===null ? <span>{ p.minOrders }+ zamówienia / miesiąc</span> : ''}
                          </div>
                        </div>
                      :
                        <div class='range-tooltip-inner'>
                          <div class="call-us-wrapper"><span>Po więcej informacji na temat planu subskrypcji</span>
                            <stencil-route-link class='item' url={URLS.AppContactPage}>
                              <span class='item-link'>
                                Skontaktuj się z nami
                              </span>
                            </stencil-route-link>
                          </div>
                          <div class='turnover-rage-price'>
                            {/* <p>&gt; €{ formatAmount(p.minTurnover) } sprzedaży / rok</p> */}
                            <p>&gt; { p.minOrders } zamówienia / miesiąc</p>
                          </div>
                        </div>
                      }
                </div>
              </li>
            })}
          </ul>
        </div>

        {/* <div class='price-page-info-wraper'>
          <p>Zento is publicly available.</p>
          <p>Lock in your price and get <strong>20% off your setup fee</strong> by making a fully refundable deposit of <strong>1,000 EUR today.</strong></p>
        </div> */}

        <div class='page-items-button'>
          <span
            class='popup-button'
            onClick={ this.openModaldHandler.bind(this) }
          >
            Aplikuj teraz
          </span>

          <app-modal
            showModal={ this.showModal }
          >
            <app-lock-in-price
              showSubmitMessage={ !this.showModal }
            />
          </app-modal>
        </div>

        <div class='subscription-services-wrapper'>
          <div class='subscription-services'>
            <h2 class='subtitle'>Co obejmuje usługa subskrypcji Zento?</h2>
            <div class='subscription-services-items'>
              <div class='subscription-services-item'>
                <div class='subscription-services-img'>
                  <picture>
                    <img
                      src='../../assets/icon/i_hosting.svg'
                      alt='Hosting, monitoring, and maintenance'
                      loading='lazy'
                    />
                  </picture>
                </div>
                <div class='subscription-services-title'>
                  <h3>Hosting, monitorowanie i konserwacja</h3>
                </div>
              </div>
              <div class='subscription-services-item'>
                <div class='subscription-services-img'>
                  <picture>
                    <img
                      src='../../assets/icon/i_zento-license.svg'
                      alt='Zento license'
                      loading='lazy'
                    />
                  </picture>
                </div>
                <div class='subscription-services-title'>
                  <h3>Licencja Zento z bieżącymi wydaniami funkcji + oficjalne aktualizacje Magento i aktualizacje wersji</h3>
                </div>
              </div>
              <div class='subscription-services-item'>
                <div class='subscription-services-img'>
                  <picture>
                    <img
                      src='../../assets/icon/i_technical-support.svg'
                      alt='Technical support and consultancy'
                      loading='lazy'
                    />
                  </picture>
                </div>
                <div class='subscription-services-title'>
                  <h3>Wsparcie techniczne i doradztwo</h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="responsability-chart-wrapper">
          <div class="responsability-chart-inner">
            <h2>Co obejmuje miesięczna subskrypcja <strong>{ AppPriceSlider.pricing[this.sliderValue-1].subscription ? '€'+new Intl.NumberFormat('en-US').format(AppPriceSlider.pricing[this.sliderValue-1].subscription) : '' }</strong></h2>
            <div class="responsability-chart">
              <table>
                <tbody>
                  <tr class="responsability-chart-heading">
                    <th>Zento SaaS Subskrypcja</th>
                    <td>Zento</td>
                    <td>Ty</td>
                  </tr>
                  {AppPriceSlider.includedBullets.subscription.map(item => {
                    return <tr>
                      <th>
                        { item.link !== null ?
                          <stencil-route-link url={ item.link }>
                            <span>{ item.label } </span><em>ⓘ</em>
                          </stencil-route-link>
                        : <span>{ item.label } </span> }
                      </th>
                      <td>
                        { item.zento ?
                          <picture>
                            <img
                            class='img'
                            src='../../assets/icon/i_checkmark.svg'
                            alt='Zento'
                            loading='lazy'
                            />
                          </picture>
                        : '' }
                      </td>
                      <td>
                        { item.merchant ?
                          <picture>
                            <img
                            class='img'
                            src='../../assets/icon/i_checkmark.svg'
                            alt='Merchant'
                            loading='lazy'
                            />
                          </picture>
                        : '' }
                      </td>
                    </tr>
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="responsability-chart-wrapper">
          <div class="responsability-chart-inner">
            <h2>Co obejmuje konfiguracja za <strong>{ AppPriceSlider.pricing[this.sliderValue-1].setup ? '€' + new Intl.NumberFormat('en-US').format(AppPriceSlider.pricing[this.sliderValue-1].setup) : '' }</strong>?</h2>
            <div class="responsability-chart">
              <table>
                <tbody>
                  <tr class="responsability-chart-heading">
                    <th>Konfiguracja</th>
                    <td>Zento</td>
                    <td>Ty</td>
                  </tr>
                  {AppPriceSlider.includedBullets.setup.map(item => {
                    return <tr>
                      <th>
                        { item.link !== null ?
                          <stencil-route-link url={ item.link }>
                            <span>{ item.label } </span><em>ⓘ</em>
                          </stencil-route-link>
                        : <span>{ item.label } </span> }
                      </th>
                      <td>
                        { item.zento ?
                          <picture>
                            <img
                            class='img'
                            src='../../assets/icon/i_checkmark.svg'
                            alt='Zento'
                            loading='lazy'
                            />
                          </picture>
                        : '' }
                      </td>
                      <td>
                        { item.merchant ?
                          <picture>
                            <img
                            class='img'
                            src='../../assets/icon/i_checkmark.svg'
                            alt='Merchant'
                            loading='lazy'
                            />
                          </picture>
                        : '' }
                      </td>
                    </tr>
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="responsability-chart-wrapper">
          <div class="responsability-chart-inner">
            <h2>Co obejmuje szacowany hosting <strong>{ AppPriceSlider.pricing[this.sliderValue-1].hosting ? '€' + new Intl.NumberFormat('en-US').format(AppPriceSlider.pricing[this.sliderValue-1].hosting) : '' }</strong>?</h2>
            <div class="responsability-chart">
              <table>
                <tbody>
                  <tr class="responsability-chart-heading">
                    <th>Hosting</th>
                    <td>Zento</td>
                    <td>Ty</td>
                  </tr>
                  <tr>
                    <th><stencil-route-link url='/wiki/hosting/architecture' class='tabel-link'><span>Konfiguracja Zento</span></stencil-route-link> natywna dla chmury umożliwia precyzyjne śledzenie wszystkich
                      zasobów hostingowych wykorzystywanych w AWS przez Twój sklep za pomocą tagów alokacji kosztów AWS. Więcej informacji na temat tej funkcji można znaleźć w naszym artykule Wiki dotyczącym
                      śledzenia kosztów. Miesięczny raport dotyczący całego zużycia hostingu będzie dostępny wraz z fakturą.</th>
                    <td>
                      <picture>
                        <img
                        class='img'
                        src='../../assets/icon/i_checkmark.svg'
                        alt='Zento'
                        loading='lazy'
                        />
                      </picture>
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
